  <novo-toolbar>
    <novo-toolbar-row accent="lead" gap="md">
      <novo-icon>list</novo-icon>
      <novo-title>Import Queue</novo-title>
      <span class="example-spacer" flex="1"></span>
      <novo-action icon="times" tooltip="Close" (click)="close()"></novo-action>
    </novo-toolbar-row>
  </novo-toolbar>
  <section padding="lg">
    <novo-data-table [rows]="queuedItems"
      [columns]="columns"
      [allowMultipleFilters]="true"
      [displayedColumns]="displayedColumns"
      [hideGlobalSearch]="true"
      [paginationOptions]="paginationOptions"
      [selectionOptions]="selectionOptions"
      [activeRowIdentifier]="selectedRecordId"
      name="cubex-monster-jobs-queued"
      #modalTable
      >

      <ng-template novoTemplate="customActions">
        <novo-dropdown side="right" *ngIf="modalTable.state.selected.length !== 0">
          <button theme="primary"
            icon="collapse"
            inverse>
            <span>Actions</span>
          </button>
          <list>
            <item (click)="addToLeadQueue()">Add Selected to Queue (Lead)</item>
            <item (click)="addToCustomObjectQueue()">Add Selected to Queue (Custom Object)</item>
          </list>
        </novo-dropdown>
      </ng-template>
      <ng-template novoTemplate="url" let-row>
        <a [href]="row.url" target="_blank">URL</a>
      </ng-template>
  </novo-data-table>
  </section>
